/*
 * Copyright (c) 2020
 * Company: G-Portal
 * Filename: mutations.ts
 * Class: mutations.ts
 * Author: Karl Magerl<karl@g-portal.com>
 * Version:
 */

import { MutationTree } from 'vuex';
import { AdditionalPaymentDetailsResponse, PaymentState } from './types';
import { MutationRequestStatus } from '../types';
import { getDefaultErrorState, getDefaultLoadingState, getDefaultState } from '../utils';

export const mutations: MutationTree<PaymentState> = {
  getPaymentLoading: (state) => state.getPayment = { ...getDefaultLoadingState() },
  getPaymentLoaded: (state, payload) => state.getPayment = {
    ...getDefaultState(),
    status: MutationRequestStatus.SUCCESS,
    data: payload,
  },
  getPaymentError: (state) => state.getPayment = { ...getDefaultErrorState() },

  disableSavedPaymentMethodReset: (state) => state.disableMethod = { ...getDefaultState() },
  disableSavedPaymentMethodLoading:
    (state) => state.disableMethod = { ...getDefaultLoadingState() },
  disableSavedPaymentMethodLoaded: (state) => {
    state.disableMethod = {
      error: undefined,
      data: undefined,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  disableSavedPaymentMethodError: (state, payload) => {
    state.disableMethod = {
      ...getDefaultErrorState(),
      data: payload,
    };
  },

  createPaymentLoading: (state) => state.createPayment = { ...getDefaultLoadingState() },
  createPaymentSuccess: (state, payload) => {
    state.createPayment = {
      error: undefined,
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  createPaymentError: (state, payload) => {
    state.createPayment = {
      ...getDefaultErrorState(),
      error: payload,
    };
  },
  createPaymentReset: (state, payload) => state.createPayment = { ...getDefaultState() },

  additionalPaymentDetailsLoading: (state) => {
    state.additionalPaymentDetails = {
      ...getDefaultLoadingState(),
    };
  },
  additionalPaymentDetailsSuccess: (state, payload: AdditionalPaymentDetailsResponse) => {
    state.additionalPaymentDetails = {
      error: undefined,
      data: payload,
      status: MutationRequestStatus.SUCCESS,
    };
  },
  additionalPaymentDetailsError: (state, payload) => {
    state.additionalPaymentDetails = {
      ...getDefaultErrorState(),
      error: payload,
    };
  },
  verifyLoading: (state) => {
    state.verifyPayment = {
      ...getDefaultLoadingState(),
    };
  },
  verifySuccess: (state, payload) => {
    state.verifyPayment = {
      ...getDefaultState(),
      data: payload,
    };
  },
  verifyError: (state, error) => {
    state.verifyPayment = {
      ...getDefaultErrorState(),
      error,
    };
  },
};
